// Original Wix image positions. Index 0 is the shared brand image.
export const TECHNICAL_IMAGE_INDEXES = {
  "ALIMENTADOR DE PLACAS DE ALTA RESISTENCIA ZSBZH": [
    3
  ],
  "ALIMENTADOR VIBRATORIO ZSW": [
    4
  ],
  "CAMIÓN HORMIGONERA AUTOCARGABLE SHZ": [
    5
  ],
  "CLASIFICADOR MINERAL DE CARBÓN FP": [
    2
  ],
  "COLECTOR DE POLVO DE BOLSAS PULSANTES DMC": [
    3
  ],
  "CONTRAATAQUE TIPO MARTILLO DE UNA ETAPA ZSPCD": [
    2
  ],
  "CRIBA VIBRATORIA CIRCULAR ZSTS": [
    3
  ],
  "CRIBA VIBRATORIA CIRCULAR ZSYK": [
    2
  ],
  "EQUIPO DE RECUPERACIÓN DE ARENA FINA": [
    2
  ],
  "ESTACIÓN MÓVIL DE TRITURACIÓN DE CONO SOBRE ORUGAS MC": [
    2
  ],
  "ESTACIÓN MÓVIL DE TRITURACIÓN DE IMPACTO SOBRE ORUGAS MHYP": [
    2
  ],
  "ESTACIÓN MÓVIL DE TRITURACIÓN DE MANDÍBULAS SOBRE ORUGAS MJ": [
    1
  ],
  "HORMIGONERA JS": [
    4
  ],
  "Lavadora de arena de rueda de cangilones.": [
    4
  ],
  "LAVADORA DE ARENA EN ESPIRAL": [
    5
  ],
  "MÁQUINA CENTRÍFUGA DE FABRICACIÓN DE ARENA IMPACTADA DE ALTA EFICIENCIA": [
    4
  ],
  "MÁQUINA INTEGRADA DE LAVADO DE ARENA Y RECICLADO DE ARENA FINA": [
    3
  ],
  "Máquina para fabricar arena compuesta vertical serie.": [
    2
  ],
  "MOLINO DE BOLAS": [
    2
  ],
  "MOLINO DE POLVO ULTRAFINO HGM": [
    4
  ],
  "MOLINO DE SUSPENCIÓN DE ALTA PRESIÓN": [
    3
  ],
  "MOLINO RAYMOND": [
    5
  ],
  "MOLINO TRAPEZOIDAL MTW": [
    4,
    5
  ],
  "MOLINO TRAPEZOIDAL TGM": [
    2
  ],
  "MOLINO VERTICAL VM": [
    2
  ],
  "PLANTA MEZCLADORA DE HORMIGÓN HZS": [
    5
  ],
  "PLANTA MÓVIL DE CRIBADO DE NEUMÁTICOS ZSC": [
    2
  ],
  "PLANTA MÓVIL DE CRIBADO SOBRE ORUGAS MS": [
    2
  ],
  "PLANTA MÓVIL DE FABRICACIÓN DE ARENA DE NEUMÁTICOS ZSLY": [
    2
  ],
  "PLANTA MÓVIL DE SEPARACIÓN DE LODOS Y GRAVAS ZSG": [],
  "PLANTA MÓVIL TRITURADORA DE CONO DE NEUMÁTICOS ZSY": [
    2
  ],
  "SEPARADOR DE TIERRA Y PIEDRAS DE RODILLOS GZS": [
    4
  ],
  "TRANSPORTADOR DE CORREA B": [
    6
  ],
  "TRITURADORA DE CONO COMPUESTA PY": [
    2
  ],
  "TRITURADORA DE CONO HIDRÁULICA DE UN CILINDRO GP": [
    2,
    3
  ],
  "TRITURADORA DE CONO MULTICILÍNDRICA TOTALMENTE HIDRÁULICA": [
    2
  ],
  "TRITURADORA DE IMPACTO EUROPEA PFW": [
    1
  ],
  "TRITURADORA DE IMPACTO PF": [
    4
  ],
  "TRITURADORA DE MANDÍBULA PEQUEÑA": [
    1
  ],
  "TRITURADORA DE MANDÍBULAS MÓVIL ZSE": [
    2
  ],
  "TRITURADORA DE MANDÍBULAS PE/PEX": [
    2
  ],
  "TRITURADORA DE MANDÍBULAS VERSIÓN EUROPEA ZSC": [
    2
  ],
  "TRITURADORA DE MARTILLOS PEQUEÑA PC": [
    3
  ],
  "TRITURADORA DE RODILLOS PGC": [
    2
  ],
  "TRITURADORA FINA DE ALTA EFICACIA ZSPCX": [
    2
  ],
  "TRITURADORA MÓVIL DE CONTRAATAQUE DE NEUMÁTICOS PLANTA MÓVIL ZSF": [
    2
  ]
};
